module.exports = __webpack_public_path__ + "static/media/section05_01.9c0f7244.jpg";